import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { environment } from 'src/environments/environment';
import { AppConfigService } from 'src/app/core/config/config.service';
import { ReportstUri, FinanceUri } from 'src/app/core/config/config.model';

@Injectable({ providedIn: 'root' })

export class ReportsUriService {
    private baseUrl: string;
    private financeUri: FinanceUri;
    private reportsUri: ReportstUri;

    constructor
        (private urlService: UrlService, private apiConfig: AppConfigService) {
        this.baseUrl = environment.baseUrl;
        this.financeUri = apiConfig.appConfig.financeUri;
        this.reportsUri = apiConfig.appConfig.reportsUri;
    }

    getCurrenciesUri() {
        return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.currency);
    }

    getProvidersUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.providers);
    }

    getCascadeInvoiceItemReportUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.sales_report)
    }

    getDigitalOrdersUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.order_items)
    }
    
    getDigitalOrdersArchiveUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.order_items_archive)
    }

    getDebitCreditNoteListUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.finance, this.reportsUri.notes)
    }
}